currentVersion = "v2"
themeSet = "custom"
title = "Babyfur Interest Benchmark"
subtitle = "What brings you to ABDL/Babyfur?"
nameLabel = "Name"
attributeTerm = "interest"
attributeTermPlural = "interests"
datasetColors = [
  "#4a90e2", # Default Accent
  "#22c55e", # Green
  "#f59e0b", # Amber
  "#6366f1", # Indigo
  "#ec4899", # Pink
  "#06b6d4", # Cyan
]

[versions.v1]
attributeIds = [
  "diapers",
  "little",
  "middle",
  "big",
  "wetting",
  "messing",
  "regression",
  "artwork",
  "chastity",
  "bondage",
  "humiliation",
  "fursuits",
  "kink",
]
minRating = 0
maxRating = 10
labelInterval = 2

[versions.v2]
attributeIds = [
  "diapers",
  "toys",
  "little",
  "middle",
  "big",
  "wetting",
  "messing",
  "regression",
  "artwork",
  "chastity",
  "bondage",
  "humiliation",
  "fursuits",
  "kink",
  "ds",
  "breastfeeding",
]
minRating = 0
maxRating = 10
labelInterval = 2

[defaultLabels]
0 = "Hard Boundary"
1 = "Averse"
2 = "Tolerant"
3 = "Ambivalent"
4 = "Curious"
5 = "Interested"
6 = "Enjoys"
7 = "Preference"
8 = "Important"
9 = "Essential"
10 = "Core Identity"

[[attributes]]
id = "diapers"
name = "Diapers"
description = "Wearing/Using Diapers"
category = "Physical"

[[attributes]]
id = "little"
name = "Little"
description = "Roleplaying as a Little"
category = "Age Play"

[[attributes]]
id = "middle"
name = "Middle"
description = "Roleplaying as a Middle"
category = "Age Play"

[[attributes]]
id = "big"
name = "Caregiver"
description = "Caring for Others"
category = "Age Play"

[[attributes]]
id = "wetting"
name = "Wetting"
description = "Wetting Diapers"
category = "Physical"

[[attributes]]
id = "messing"
name = "Messing"
description = "Messing Diapers"
category = "Physical"

[[attributes]]
id = "regression"
name = "Regression"
description = "Feeling like someone/something else has made you little."
category = "Age Play"

[[attributes]]
id = "artwork"
name = "Artwork"
description = "Appreciating (or creating) artwork in this space."
category = "Creative"

[[attributes]]
id = "chastity"
name = "Chastity"
description = "Preventing sexual activity"
category = "Kink / BDSM"

[[attributes]]
id = "bondage"
name = "Bondage"
description = "Restrained movement"
category = "Kink / BDSM"

[[attributes]]
id = "humiliation"
name = "Humiliation"
description = "Embarassment or Teasing"
category = "Kink / BDSM"

[[attributes]]
id = "fursuits"
name = "Fursuits"
description = "Wearing/Appreciating Fursuits"
category = "Creative"

[[attributes]]
id = "kink"
name = "Kink/Sexual"
description = "Being aroused by activities"
category = "Kink / BDSM"

[[attributes]]
id = "ds"
name = "D/s Dynamic"
description = "Power exchange or Dom/Sub Dynamic"
category = "Kink / BDSM"

[[attributes]]
id = "breastfeeding"
name = "Breastfeeding"
description = "(Simulated or Real) Breastfeeding"
category = "Kink / BDSM"

[[attributes]]
id = "toys"
name = "Toys & Accessories"
description = "Age-appropriate toys, games, and environment"
category = "Physical"